<template>
    <div class="searchWrapper">
        <input type="text" :class="showSearchInput" class="searchInput" value="" placeholder="Type to search" v-on:blur="hideSearch()"  ref="search" v-model="searchCriteria" @input="updateSearch"/>
        <span class="icon-search" @click="showSearch()"></span>
    </div>
</template>

<script>
export default {
    data () {
        return {
            searchCriteria: '',
        };
    },
    methods: {
        showSearch () {
            this.$refs.search.focus();
            this.$store.commit('updateSearch', this.$refs.search.value);
            this.$store.commit('ui/setNotFullscreen');
        },
        hideSearch () {
            if (this.$store.state.ui.pageView !== 'search') this.$store.commit('closeSearch', this.$refs.search.value);
            this.$store.commit('ui/toggleFullscreen');
        },
        updateSearch (e) {
            this.$store.commit('updateSearch', e.target.value);
        },
    },
    computed: {
        showSearchInput () {
            return this.$store.state.ui.pageView === 'search' ? 'active' : '';
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import 'src/assets/scss/all.scss';
.searchWrapper{
    // float: right;
    font-size: 25px;
    margin-left: 0;
    margin-right: 5px;
    vertical-align: middle;
    .icon-search{
        color: $LCPMarine;
        cursor: pointer;
        font-size: 23px;
        padding-top: 10px;
        vertical-align: middle;
    }
    .searchInput{
        @include easeInOut(0.5s);
        background-color: transparent;
		color: #000!important;
        border-color: initial;
        border-image: initial;
        border-style: none;
        border-width: 0px;
        font-size:16px;
        outline: 0;
        width: 0;
        &.active{
            border-bottom: 1px solid $LCPMarine;
            padding: 10px;
            width:200px!important;
        }
    }
}
</style>
